module.exports = __webpack_public_path__ + "img/administrator.4ecbd70b.svg";